<template lang="pug">
  .lista-clientes
    .title
      span Equipos del cliente {{ cliente.nombre }}

    .body
      table.table.is-striped.is-bordered
        thead
          th Serie
          th Modelo
          th Descripcion
          th Contrato
          th Tipo de contrato
          th
        tbody(
          name="table-row"
          is="transition-group"
        )
          tr.row-table(
            v-for="(o, index) in lista"
            :key="index"
          )
            td {{ o.serie }}
            td {{ o.modelo }}
            td {{ o.descripcion }}
            td {{ o.numeroContrato }}
            td {{ o.descripcionTipoContrato }}
            td
              .contenedor-acciones
                button.button.is-small.is-danger(@click="remover(o)") Eliminar
</template>

<script>
import { apiGet, apiDelete, notify } from '../util/general'
export default {
  name: 'cliente_equipo_list',
  props: ['cliente'],
  data () {
    return {
      isLoading: true,
      lista: [],
      clienteSeleccionado: {},
      seleccionado: false
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = { codigo: vm.cliente.codigo }
      apiGet(vm, '/admin/cliente/equipo', obj, function (data) {
        vm.lista = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    remover (o) {
      var vm = this

      var obj = {
        serie: o.serie
      }

      apiDelete(vm, '/admin/cliente/equipo', obj, function (data) {
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-acciones
    display flex
    .button
      margin 0px 10px
      flex 1
</style>



// WEBPACK FOOTER //
// Component_Cliente_Equipo_List.vue?739326f0